// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-cont {
  padding: 0px 24px 24px 24px;
}

.page-header {
  margin-bottom: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
}

.page-header h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
}

.page-header-title {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 16px;
}

.body-content {
  padding: 16px 24px;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  border-radius: 8px
}

.body-content .row {
  display: flex;
  flex-wrap: wrap;
}

.body-content .row > [class*='col-'] {
  display: flex;
  flex-direction: column;
}

.body-content .card {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.status-badge {
  display: inline-block;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 24px;
  color: #212529;
}

.section-title i {
  margin-right: 8px;
  color: #6c757d;
}

.member-details-card,
.loan-details-card {
  min-height: 500px;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
}

.loan-decision-card {
  padding: 16px;
}

.card-body {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.member-header {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
}

.avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  font-weight: 600;
  color: #495057;
}

.member-info h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #212529;
}

.details-list {
  flex-grow: 1;
  margin-top: 24px;
}

.detail-item {
  margin-bottom: 20px;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 16px;
  display: flex;
  justify-content: space-between;
}

.detail-item .label {
  color: #6c757d;
  font-size: 13px;
  margin-bottom: 4px;
}

.detail-item .value {
  font-weight: 500;
}

.loan-summary {
  margin-bottom: 24px;
}

.summary-box {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
}

.summary-box label {
  color: #666;
  font-size: 13px;
  margin-bottom: 8px;
  display: block;
}

.summary-box h4 {
  margin: 0;
  font-size: 18px;
}

.decision-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 24px;
}

.alert {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-radius: 8px;
}

.alert-warning {
  background: #fff3cd;
  border: 1px solid #ffeeba;
  color: #856404;
}

.back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 10px;
  background-color: #F7941D;
  border: none;
  transition: background-color 0.2s ease;
}

.back-btn a {
  color: white;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
}

.back-btn:hover {
  background-color: #e68612;
}

.fees-section {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}

.fees-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
}

.fees-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #495057;
  display: flex;
  align-items: center;
  gap: 8px;
}

.fees-content {
  flex-grow: 1;
}

.fees-table {
  background: white;
  border-radius: 4px;
  overflow: hidden;
}

.fees-table table {
  margin-bottom: 0;
}

.fees-table th {
  background-color: #f8f9fa;
  font-weight: 600;
  padding: 12px;
}

.fees-table td {
  padding: 12px;
  vertical-align: middle;
}

.fees-table .total-row {
  background-color: #f8f9fa;
}

.fees-table .text-right {
  text-align: right;
}

.fees-header:hover {
  color: #F7941D;
}

.fees-header i {
  transition: transform 0.2s ease;
}

.fees-header:hover i {
  transform: translateX(2px);
}

.repayment-schedule {
  margin-top: auto;
  padding-top: 24px;
}

.decision-buttons .btn-primary {
  background-color: #F7941D;
  border-color: #F7941D;
  color: white;
  padding: 10px 24px;
  font-weight: 500;
}

.decision-buttons .btn-primary:hover {
  background-color: #e68612;
  border-color: #e68612;
}

.decision-buttons .btn-primary:disabled {
  background-color: #F7941D;
  border-color: #F7941D;
  opacity: 0.65;
}`, "",{"version":3,"sources":["webpack://./src/App/pages/admin/LoanApplicationDetails.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yCAAyC;EACzC;AACF;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;EACpB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;AACf","sourcesContent":[".content-cont {\n  padding: 0px 24px 24px 24px;\n}\n\n.page-header {\n  margin-bottom: 32px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 24px;\n  background: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);\n  border-radius: 8px;\n}\n\n.page-header h2 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.page-header-title {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-left: 16px;\n}\n\n.body-content {\n  padding: 16px 24px;\n  background: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);\n  border-radius: 8px\n}\n\n.body-content .row {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.body-content .row > [class*='col-'] {\n  display: flex;\n  flex-direction: column;\n}\n\n.body-content .card {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 6px 16px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.section-title {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 24px;\n  color: #212529;\n}\n\n.section-title i {\n  margin-right: 8px;\n  color: #6c757d;\n}\n\n.member-details-card,\n.loan-details-card {\n  min-height: 500px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 16px;\n}\n\n.loan-decision-card {\n  padding: 16px;\n}\n\n.card-body {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.member-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 24px;\n  padding: 16px;\n  background: #f8f9fa;\n  border-radius: 8px;\n}\n\n.avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: #e9ecef;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 16px;\n  font-weight: 600;\n  color: #495057;\n}\n\n.member-info h4 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #212529;\n}\n\n.details-list {\n  flex-grow: 1;\n  margin-top: 24px;\n}\n\n.detail-item {\n  margin-bottom: 20px;\n  border-bottom: 1px solid #e9ecef;\n  padding-bottom: 16px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.detail-item .label {\n  color: #6c757d;\n  font-size: 13px;\n  margin-bottom: 4px;\n}\n\n.detail-item .value {\n  font-weight: 500;\n}\n\n.loan-summary {\n  margin-bottom: 24px;\n}\n\n.summary-box {\n  background: #f8f9fa;\n  padding: 16px;\n  border-radius: 8px;\n}\n\n.summary-box label {\n  color: #666;\n  font-size: 13px;\n  margin-bottom: 8px;\n  display: block;\n}\n\n.summary-box h4 {\n  margin: 0;\n  font-size: 18px;\n}\n\n.decision-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 16px;\n  margin-top: 24px;\n}\n\n.alert {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  border-radius: 8px;\n}\n\n.alert-warning {\n  background: #fff3cd;\n  border: 1px solid #ffeeba;\n  color: #856404;\n}\n\n.back-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-right: 10px;\n  background-color: #F7941D;\n  border: none;\n  transition: background-color 0.2s ease;\n}\n\n.back-btn a {\n  color: white;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.back-btn:hover {\n  background-color: #e68612;\n}\n\n.fees-section {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 16px;\n}\n\n.fees-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 8px;\n}\n\n.fees-header h4 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #495057;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.fees-content {\n  flex-grow: 1;\n}\n\n.fees-table {\n  background: white;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.fees-table table {\n  margin-bottom: 0;\n}\n\n.fees-table th {\n  background-color: #f8f9fa;\n  font-weight: 600;\n  padding: 12px;\n}\n\n.fees-table td {\n  padding: 12px;\n  vertical-align: middle;\n}\n\n.fees-table .total-row {\n  background-color: #f8f9fa;\n}\n\n.fees-table .text-right {\n  text-align: right;\n}\n\n.fees-header:hover {\n  color: #F7941D;\n}\n\n.fees-header i {\n  transition: transform 0.2s ease;\n}\n\n.fees-header:hover i {\n  transform: translateX(2px);\n}\n\n.repayment-schedule {\n  margin-top: auto;\n  padding-top: 24px;\n}\n\n.decision-buttons .btn-primary {\n  background-color: #F7941D;\n  border-color: #F7941D;\n  color: white;\n  padding: 10px 24px;\n  font-weight: 500;\n}\n\n.decision-buttons .btn-primary:hover {\n  background-color: #e68612;\n  border-color: #e68612;\n}\n\n.decision-buttons .btn-primary:disabled {\n  background-color: #F7941D;\n  border-color: #F7941D;\n  opacity: 0.65;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
